const IMPLIED_WARRANTY_COLUMNS = {
  id: 'Id',
  label: 'Label',
  individualPeriod: 'Individual period',
  corporatePeriod: 'Corporate period',
  name: 'Name',
  street: 'Street',
  postCode: 'Postal code',
  city: 'City',
  countryCode: 'Country code',
  description: 'Description',
} as const;

export default IMPLIED_WARRANTY_COLUMNS;
